import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PdfFlowService {
  flow = { id: null, extra: {} };

  constructor() {}

  getSelectedFlow() {
    return of(null);
  }
}
